import { updateEverExpanded } from './index';
import serverApi from '../services/serverApi';

export const firstExpand = () => {
  return async function(dispatch, getState) {
    if (
      getState().experiments['specs.chat.LeadCaptureFormV2'] &&
      !getState().everExpanded
    ) {
      dispatch(updateEverExpanded(true));
      await serverApi.reportFirstExpand(getState().allowInput);
    }
  };
};
